import React, { useState } from 'react'
import DatePicker, { registerLocale } from 'react-datepicker'
import getYear from 'date-fns/getYear'
import range from "lodash/range";
import Icon from '../../Images/icon-calendar.svg'
import Select from 'react-select'
import de from 'date-fns/locale/de';

const BirthdayPicker = (props) => {

	registerLocale('de', de)


	
	// Datepicker Settings
	const [startDate, setStartDate] = useState({
		[props.client]: props.data[props.client] && props.data[props.client].date !== '' ? new Date(props.data[props.client].date) : ''
	});
	
	const handleUpdate = (v) => { 

		setStartDate({
			...startDate,
			[props.client]: v
		})
		props.handleUpdate({
			...props.data,
			[props.client]: {
				...props.data[props.client],
				date: v
			}
		})
	}

	const years = range(1910, getYear(new Date()) + 1, 1);
	const months = [
	  "Januar",
	  "Februar",
	  "März",
	  "April",
	  "Mai",
	  "Juni",
	  "Juli",
	  "August",
	  "September",
	  "Oktober",
	  "November",
	  "Dezember",
	];

	const yearsList = [];
	years.map(y => { 
		return yearsList.push({label: y, value: y})
	})

	const yearOptions = yearsList.reverse();

	const monthsList = []
	months.map(m => monthsList.push({label: m, value: m}))



	return (
		<div className="no__input-group">
			<label>Geburtsdatum{props.required ? '*' : '' }</label>
			<div className="no__datepicker">
				<div className="no__datepicker-wrapper">
					<DatePicker
						dateFormat="dd.MM.yyyy"
						locale="de"
						required={props.required}
						renderCustomHeader={({
							date,
							changeYear,
							changeMonth,
						}) => (
							<div
								className="no__flex-justify"
							>
								<Select
									className="no__dropdown"
									onChange={({value}) => changeYear(value)}
									defaultValue={new Date().getFullYear()}
									options={yearOptions}
									placeholder={new Date().getFullYear()}
									noOptionsMessage={() => 'Kein Treffer'}
								/>
								<Select
									className="no__dropdown"
									onChange={({value}) => changeMonth(months.indexOf(value))}
									defaultValue={monthsList[0]}
									options={monthsList}
									placeholder={monthsList[0]}
									noOptionsMessage={() => 'Kein Treffer'}
								/>
							</div>
						)}
							selected={startDate[props.client]}
							onChange={(date) => handleUpdate(date)}
						
				/>
				<img src={ Icon } alt="Kalender" className="no__icon"/>
			</div>
			</div>
		</div>
	)
}

export default BirthdayPicker
